import { EMOJI_KEY } from '@techchange/pm-specs';

/**
 * Inserts an emoji node at the current selection.
 *
 * @param {Object} attrs  The emoji attributes.
 *
 * @returns {Function} Parametrized command to insert an emoji.
 *
 */
export const insertEmoji = (attrs) => {

	return (state, dispatch) => {

		const { schema, tr } = state;

		const emojiNodeType = schema.nodes[EMOJI_KEY];

		const newEmojiNode = emojiNodeType.create(attrs);

		tr.replaceSelectionWith(newEmojiNode);

		if (dispatch) {

			dispatch(tr);

		}

		return true;

	};

};
